
// => Styling
import styles from './Choice.module.css';

// => Custom hooks
import { useKeyboardShortcut } from '../../../hooks/useKeyboardShortcut.tsx';

// => React hooks
import { useRef, useState } from 'react';


// ============
// Component
// ============
const Choice = ({
    label = "No text",
    index = -1,
    onChoice = () => {}
}) => {

    const refBtn = useRef()
    const [active, setActive] = useState(false)

    const enableShortcut = () => {
        return (index >= 0 && index <= 9)
    }

    useKeyboardShortcut({
        key: enableShortcut() ? String(index+1) : null,
        onKeyPressed: () => {
            refBtn.current?.click()
            setActive(true)
            setTimeout(() => {
                setActive(false)
            }, 100);
        },
        onKeyUp: () => {
            setTimeout(() => {
                setActive(false)
            }, 40)
        }
    })


    // RENDER
    // ---------
    return(
        <button className={[styles.container, active ? styles.active : null].join(" ")} 
                ref={refBtn}
                autoFocus={false}
                onClick={onChoice}>
                    <span className={styles.label}>
                        {enableShortcut() && <span className={styles.key}>[{index + 1}]</span>}
                        {label}
                    </span>
        </button>
    )
}


export default Choice